import { PktConsent } from '..'

export default function Consent() {
  return (
    <main className="page-main pkt-container pkt-container--laptop">
      <h1>Consent</h1>

      <section className="component">
        <PktConsent
          onToggleConsent={(e) => {
            console.log('detail 1:', e.detail)
          }}
        />
      </section>
      <section className="component">
        <PktConsent
          triggerType="link"
          onToggleConsent={(e) => {
            console.log('detail 2:', e.detail)
          }}
        />
      </section>
      <section className="component">
        <PktConsent
          triggerType="icon"
          onToggleConsent={(e) => {
            console.log('detail 3:', e.detail)
          }}
        />
      </section>
    </main>
  )
}
